import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactEditor, useSlate } from 'slate-react'
import { someNode } from '@udecode/slate-plugins'

import BaseElement from './BaseElement';

export function renderDocumentHeaderElement(params) {
  return (props) => {
    if (props.element.type === 'document_header') { 
      return (
          <DocumentHeaderElement {...props} {...params} />
      );
    }
  
    return undefined;
  }

}



export const DocumentHeaderPlugin = (params) => ({
  renderElement: renderDocumentHeaderElement(params),
});

export default function DocumentHeaderElement({ attributes, element, children, ...props }) {
  const { t } = useTranslation();
  const editor = useSlate();
  const path = ReactEditor.findPath(editor, element);
  const hasImage = someNode(editor, { at: path, match: (n) => n.type === 'image' })


  return (
    <BaseElement element={element} type="document_header" {...props}>
      {({ isEmpty }) => (
          <div {...attributes} contentEditable={hasImage ? false : undefined}>
              { isEmpty && <BaseElement.Placeholder text={t('editor.items.text')} /> }
              {children}
          </div>
      )}
    </BaseElement>
  )
}